import { useEffect, useState } from "react";
import Dropdown from "./dropdown";
import { TbDropletSearch, TbFileSearch } from "react-icons/tb";

const SpecifySearchTypeDropdown = ({
    onChange,
    initialValue,
    useIcons = false,
    className = "w-44",
    buttonStyle
}: {
    onChange: (value: string) => void;
    initialValue: string;
    useIcons?: boolean;
    className?: string;
    buttonStyle: string;
}) => {
    const options = [
        { value: "Files", label: "Files" },
        { value: "Sealog Events", label: "Sealog Events" },
    ];

    const [selectedOption, setSelectedOption] = useState(initialValue);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setSelectedOption(initialValue);
    }, [initialValue]);

    const handleChange = (optionValue: string) => {
        setSelectedOption(optionValue);
        onChange(optionValue);
        setIsOpen(false);
    };

    const getIcon = (value: string) => {
        switch (value) {
            case "Files":
                return <TbFileSearch size={20} />;
            case "Sealog Events":
                return <TbDropletSearch size={20} />;
            default:
                return <TbFileSearch size={20} />;
        }
    };

    return (
        <Dropdown
            label={useIcons ? getIcon(selectedOption) : selectedOption}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            className={className}
            buttonStyle={`${buttonStyle} bg-blue-50`}
        >
            <div className="bg-white shadow rounded border">
                {options.map((option) => (
                    <div key={option.value}>
                        <button
                            type="button"
                            onClick={() => handleChange(option.value)}
                            className={`${useIcons ? "px-1 2xl:px-3" : "px-3"
                                } flex w-full items-center py-2 text-left text-sm 
              leading-5 hover:bg-blue-300 hover:text-white whitespace-nowrap`}
                        >
                            {useIcons && getIcon(option.value)}
                            <span className={useIcons ? "ml-2" : ""}>{option.label}</span>
                        </button>
                    </div>
                ))}
            </div>
        </Dropdown>
    );
};

export default SpecifySearchTypeDropdown;
